<script>
import FormSubmissionContainer from '@/components/forms/form-submission-container.vue'
import Layout from '@layouts/main.vue'

export default {
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: 'The Form Submission page.' }],
    }
  },
  components: { Layout, FormSubmissionContainer },
}
</script>

<template>
  <Layout> <FormSubmissionContainer /> </Layout>
</template>
